export const loadImage = src =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = e => {
      reject(new Error(`Failed to load image ${src}`, { cause: e }));
    };
    img.src = src;
  });
